import { useCallback } from 'react';
import UriTemplate from 'uri-template-lite';
import { path } from '../../paths';
import { AlgorithmTestCalculationType } from '@atlas-frontend/sdk';

export function useOpenTestCalculationReport() {
  return useCallback((params: AlgorithmTestCalculationType) => {
    const url = new UriTemplate(
      `${path.outputDataTestCalculationReport}{?algorithmIds,sourceDataVersionId,valueDate,segment}`,
    ).expand({
      algorithmIds: params.algorithmIds.join(','),
      sourceDataVersionId: params.sourceDataVersionId,
      valueDate: params.valueDate,
      segment: 'outputData',
    });

    window.open(url, '_blank');
  }, []);
}
